import { arrayFind } from 'util/ts-utils'
import galleryStore from 'store/gallery-widget-store'
import globalStore from 'init/global-store'

export function set(params: { skus: Array<string>, tags: Array<string> }) {
  const { skus, tags } = galleryStore // state before set by passed in params
  galleryStore.skus = params.skus || []
  galleryStore.tags = params.tags || []
  // if this is the first time being set and the widget is not loaded yet, load it
  if (!skus && !tags) {
    const galleryLoader = arrayFind(globalStore.loaders, loader => loader.type === 'gallery')
    if (galleryLoader && !galleryLoader.getInstance()) {
      galleryLoader.initialize()
    }
  }
}
